import CloseIcon from '@mui/icons-material/Close';
import { alpha, Dialog, dialogClasses, styled, Theme } from '@mui/material';
import { DialogDataSelectProps } from './types';

import { TextFieldStyles } from 'v3/shared/components/Inputs/styles/InputFormStyles';

export const DialogDataSelectStyled = styled(Dialog)<DialogDataSelectProps>(() => ({
  [`&.${dialogClasses.container}`]: {
    backgroundColor: 'black',
  },
  [`&.${dialogClasses.paper}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  height: ' 100%',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.3rem',
  padding: '1rem 1rem 0 1rem',
}));

export const AlignRowBetween = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem',
}));

export const List = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 300,
  overflowY: 'auto',
  backgroundColor: theme.palette.primary.dark,
  margin: '1rem',
  borderRadius: '0.75rem',

  '&::-webkit-scrollbar-track': {
    background: theme.palette.secondary.main,
    borderRadius: '0.3125rem',
  },
  '&::-webkit-scrollbar': {
    width: '0.25rem',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: `${theme.palette.tertiary.light}`,
  },
}));

export const ItemContainer = styled('div')(({ theme }) => ({
  '&:hover': {
    background: theme.palette.blue.dark,
  },
}));

export const Item = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '1.5rem',
  color: theme.palette.common.white,
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const dialogStyles = (theme: Theme) => {
  return {
    backgroundColor: theme.palette.primary.main,
    border: `0.1rem solid ${alpha(theme.palette.common.white, 0.4)}`,
    boxShadow: 'none',
    borderRadius: '1rem',
    width: '100%',
    maxWidth: '37.5rem',
    height: '27.5rem',
  };
};

export const SelectFormStyled = styled(TextFieldStyles)(({ theme }) => ({
  input: {
    cursor: 'pointer',
  },
  svg: {
    color: theme.palette.common.white,
    cursor: 'pointer',
  },
}));
